// Image Name must match film short-name name and be a jpeg
// links need to be added in the following format: "https://www.youtube.com/embed/LINK"
// Images must be resized to 750x1000px

let filmData = {
    So89: {
        name: "Sommer '89",
        shortName: "so89",
        director: "Winston J. Reichelt",
        production: "Julius Wuttke & Winston J. Reichelt",
        dop: "Justus Richter",
        yop: "2022",
        desc: "In the summer of '89, a smuggler helps a group of GDR refugees cross the Austrian-Hungarian border. However, this well-intentioned act only incites outrage in his homeland.\n" +
            "\n" +
            "Inspired by the song “Sommer ‘89” by the band Kettcar.",
        awards: [],
        link: "about:blank"
    },
    coex: {
        name: "Command Exit",
        shortName: "coex",
        director: "Mika Rau & Winston J. Reichelt",
        production: "Jugendfilmcamp Arendsee",
        dop: "Ben Job",
        yop: "2021",
        desc: "Newton, a unremarkable programmer, works for a big tech company. When he finds out what iTech actually builds, his uprightness is put to the test.",
        awards: [],
        link: "https://www.youtube.com/embed/YVEj1a_qC_o?si=Cm0q8pa4m3JUqJMA&amp;controls=0"
    },
    mull: {
        name: "Müllschlucker",
        shortName: "mull",
        director: "Mika Rau & Winston J. Reichelt",
        production: "Jugendfilmcamp Arendsee",
        dop: "Leander Schares",
        yop: "2023",
        desc: "Since ages people discard their trash in a mysterious wooden door in the middle of an abandoned ruin. One day, a girl accidentally throws one of her belongings into the door. After trespassing she is confronted with humanities waste.",
        awards: [],
        link: "https://www.youtube.com/embed/1eBDIlbKDSg?si=eMKhIVDqR-ioVP8X"
    },
    cffw: {
        name: "Charlies Funny Fucking World",
        shortName: "cffw",
        director: "Winston J. Reichelt",
        production: "Jugendfilmcamp Arendsee",
        dop: "Tancredi Morleo",
        yop: "2019",
        desc: "In this normal sitcom, our protagonist Charlie battles with his past trauma of causing someone elses death.",
        awards: [],
        link: "https://www.youtube.com/embed/eGXXLLx3aTw?si=dMTiHWjwp3Zbxfx0"
    },
    zeit: {
        name: "Was ist Zeit?",
        shortName: "zeit",
        director: "Winston J. Reichelt",
        production: "Winston J. Reichelt",
        dop: "Winston J. Reichelt",
        yop: "2022",
        desc: "What is time? This philosophical question has occupied humanity ever since it has been able to think. The three temporal forms — \"past,\" \"present,\" and \"future\" — are embodied here by three people. They attempt to give the audience an answer to this existential question.",
        awards: [],
        link: "https://www.youtube.com/embed/AmszTknSqzA?si=kfrxdolIP_wlAWe5"
    },
    addi: {
        name: "Addicts",
        shortName: "addi",
        director: "Alex Salo",
        production: "Alex Salo",
        dop: "Winston J. Reichelt",
        yop: "2024",
        desc: "A short film about two people who battle their addiction. Ultimately they end up meeting each other.",
        awards: [],
        link: "about:blank"
    },
    cool: {
        name: "Einfach Cool bleiben",
        shortName: "cool",
        director: "Mika Rau & Winston J. Reichelt",
        production: "Jugendfilmcamp Arendsee",
        dop: "Leander Schares",
        yop: "2023",
        desc: "Two wannabe-gangster try to sell their product but get caught in a severe misunderstanding.",
        awards: [],
        link: "about:blank"
    },
    shst: {
        name: "A Shorts Story",
        shortName: "shst",
        director: "Rebekka Sailer",
        production: "Winston J. Reichelt",
        dop: "Yannick Picaper",
        yop: "2024",
        desc: "This is a project supported by the Freie Filmwerkstatt, an independent student organization at Freie Universität Berlin.\n" +
            "The short film is based on a 1904 short film titled \"An Interesting Story.\"",
        awards: [],
        link: "https://www.youtube.com/embed/4u8ArGuJK1Y?si=Lhva94K_bTbuOd9h"
    },
    retu: {
        name: "Reverse Turing",
        shortName: "retu",
        director: "Mika Rau & Winston J. Reichelt",
        production: "Jugendfilmcamp Arendsee",
        dop: "Winston J. Reichelt",
        yop: "2024",
        desc: "In a secret cooperate experiment, a human is stuck in a room full of AI's. The AI's have to find out which one of them the human is and kill him.",
        awards: [],
        link: "about:blank"
    },
    winx: {
        name: "Out of Sync",
        shortName: "winx",
        director: "Melissa Bärtl",
        production: "Melissa Bärtl",
        dop: "Winston J. Reichelt",
        yop: "2025",
        desc: "Musa battles her exam-fear while at the same time coping with her secret love for one of her friends.",
        awards: [],
        link: "about:blank"
    }
}

export default filmData;